/* System defined core library */
import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

/* User defined library/components */
import { LoaderService } from '../../services/loader.service';
import { LoaderState } from '../../models/common/loader.model';

/* Images */
const loaderAsset = require('../../../../../Assets/images/grey-loading-95px-transparent.gif');

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})

export class LoaderComponent {

  /* User defined private/public variables */
  public loaderGif = loaderAsset;
  public enableSpinner: Boolean = false;

  /* Subscriptions */
  private subscription: Subscription;

  /* Constructor declaration with required injected services */
  constructor(
    private translate: TranslateService,
    private loaderService: LoaderService
  ) {
    this.subscription = this.loaderService.loaderState.subscribe(
      (state: LoaderState) => {
        this.enableSpinner = state.show;
    });
  }

  /* Unsubscribe the subscription when component is unloaded */
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}